// First-touch UTM capture — az első látogatás paramétereit eltesszük a
// sessionre, hogy a foglalási űrlap akkor is tudja a forrást, ha a látogató
// időközben másik oldalra navigált.
const KEY = 'oc_utm_v1';
const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export const captureUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const found = {};
    FIELDS.forEach((f) => { const v = p.get(f); if (v) found[f] = v.slice(0, 120); });
    if (Object.keys(found).length === 0) return;
    const prev = JSON.parse(sessionStorage.getItem(KEY) || '{}');
    sessionStorage.setItem(KEY, JSON.stringify({ ...found, ...prev }));
  } catch { /* ignore */ }
};

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); }
  catch { return {}; }
};
